import styled from 'styled-components';

export const StyledSection = styled.section`
    padding-bottom: 80px;
    @media (max-width: 768px) {
        padding-bottom: 40px;
    }
`;
